
import { useState, useEffect, useRef } from 'react';
import { FaCheckCircle, FaChevronRight } from 'react-icons/fa';
import { API_BASE_URL } from '../../Api/config';
 import { useNavigate } from 'react-router-dom';
 import axios from 'axios';
 import apiClient from '../../Api/apiClient';

 import Swal from 'sweetalert2';
 import searchIconImage from "../../Assets/icon/freeTenderSearchIcon.png";
import { RxCross2 } from 'react-icons/rx';
 

const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [sectors, setSectors] = useState([]);
  const [subSectors, setSubSectors] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSector, setSelectedSector] = useState(null);
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [expandedSector, setExpandedSector] = useState(null);
  const [loadingCategories, setLoadingCategories] = useState(true);
  const [loadingSectors, setLoadingSectors] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredCategories, setFilteredCategories] = useState([]);

  const categoryRefs = useRef([]);
  const sectorRefs = useRef([]);
  const navigate = useNavigate()

  const fetchCategories = async () => {
    try {
      setLoadingCategories(true);
      const response = await axios.get(`${API_BASE_URL}/user/visitor/category`);
      const filterByStatus = response.data?.data?.filter(tender => tender.status === 1);
      const categories = filterByStatus || [];
      setCategories(categories);
      setFilteredCategories(categories);

      if (categories.length > 0) {
        setSelectedCategory(categories[0].id);
        fetchSectors(categories[0].id);
      }
    } catch (err) {
      console.error('Failed to fetch categories.', err);
    } finally {
      setLoadingCategories(false);
    }
  };

  const fetchSectors = async (categoryId) => {
    try {
      setLoadingSectors(true);
      const response = await axios.get(`${API_BASE_URL}/user/visitor/sector`);
      const filterByStatus = response.data?.data?.filter(tender => tender.sector_status === 1);
      const sectors = filterByStatus || [];
      const filteredSectors = sectors.filter(sector => sector.category_id === categoryId);
      setSectors(filteredSectors);
    } catch (err) {
      console.error('Failed to fetch sectors.', err);
    } finally {
      setLoadingSectors(false);
    }
  };

  const handleSubSectorSelect = categoryName => {

    navigate('/limitedTenderView', { state: { categoryName } });
    window.scrollTo(0, 0);
  };

  const fetchSubSectors = async (sector) => {
    const subSectorList = sector.sub_sectors || [];
    setSubSectors(subSectorList);
  };

  const handleCategorySelect = (categoryId, index) => {
    setSelectedCategory(categoryId);
    fetchSectors(categoryId);
    setExpandedCategory(categoryId);
    setExpandedSector(null); // Collapse any expanded sector

    // Scroll to the selected category and center it
    if (categoryRefs.current[index]) {
      categoryRefs.current[index].scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  const handleSectorSelect = (sector, index) => {
    setSelectedSector(sector.id);
    fetchSubSectors(sector);
    setExpandedSector(sector.id);

    // Scroll to the selected sector and center it
    if (sectorRefs.current[index]) {
      sectorRefs.current[index].scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    const filtered = categories.filter(category =>
      category.name.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredCategories(filtered);
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleChangePreference = async (sub_sector_id) => {
             try {
                 const response = await apiClient.patch(
                     `${API_BASE_URL}/user/tender-user/category-upazila`,
                     { sub_sector_id: sub_sector_id }
                 );
    
                 console.log('API Response:', response.data);
    
                 Swal.fire({
                   title: 'Success!',
                   text: 'The preference was updated successfully.',
                   icon: 'success',
                   confirmButtonText: 'OK',
                   customClass: {
                     popup: 'w-96 h-auto p-3',
                     title: 'text-lg',
                     content: 'text-xs',
                     confirmButton:
                       'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
                   },
                 });
    
                 navigate('/dashboard');
                
             } catch (error) {
    
                 console.error('Error fetching data:', error);
    
    
                 Swal.fire({
                     title: 'Error!',
                     text: 'There was an issue updating the preference.',
                     icon: 'error',
                     confirmButtonText: 'Try Again',
                 });
             }
         };


         const handleGoBack = () => {
             window.history.back();
         };
    

  return (
  
      <div className="min-h-screen py-1 md:mt-36  mt-28">
     <div className='flex items-center justify-between mx-2 mb-2'>
     <h1 className="text-xs sm:text-xs md:text-xl text-center mx-10 my-2  font-bold text-gradient bg-clip-text  hover:scale-105 transition-transform duration-300 ">
        Choose any sub sector of a Sector from your preferred category to Search Tenders
      </h1>
       <RxCross2 className='mr-2 cursor-pointer hover:text-red-700' size={25} onClick={handleGoBack} /> 
     </div>
      {/* Main Content */}
      <div className="w-full  mx-auto px-4 ">

        {/* Search Box */}
        <div className="relative flex items-center w-full  mb-3">
          <div className="absolute right-4 md:w-8 md:h-8 w-6 h-6 rounded-full bg-blue-500 flex items-center justify-center">
            <img src={searchIconImage} alt="Icon" className="md:w-4 md:h-4 w-3 h-3 " />
          </div>
          <input
            value={searchTerm}
            onChange={handleSearchChange}
            type="text"
            placeholder="Write Tender Categories..."
            className="flex-1 border border-gray-300 rounded-full px-3 pr-4 md:py-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-600 text-sm sm:text-base w-full"
          />
        </div>

      </div>









      {/* Categories List */}
      {loadingCategories ? (
        <div className="text-center py-4">Loading categories...</div>
      ) : (
       <div>
         <h2 className="font-bold text-sm  md:text-lg sm:text-center md:text-left w-full mx-4">All Category</h2>
        <div className="flex flex-col gap-4 md:px-4 lg:px-6 mt-4">
          {filteredCategories.length > 0 ? (
            filteredCategories.map((category, catIndex) => (
              <div key={category.id} className="border-b px-1" ref={el => categoryRefs.current[catIndex] = el}>
                <div
                  onClick={() => handleCategorySelect(category.id, catIndex)}
                  className="cursor-pointer bg-gray-100 transition-all"
                >
                  <h3
                    className={`flex items-center gap-2 rounded-lg text-gray-700 p-3 py-2 hover:bg-blue-500 hover:text-white transition-all ${expandedCategory === category.id ? 'bg-blue-700 text-white' : 'bg-gray-100'
                      }`}
                  >
                    <FaChevronRight className={`transition-transform duration-300 transform ${expandedCategory === category.id ? 'rotate-90' : ''
                      }`} /> {catIndex + 1}. {category.name}

                    {expandedCategory === category.id && <FaCheckCircle className="text-white" />}
                  </h3>
                </div>

                {expandedCategory === category.id && loadingSectors ? (
                  <div className="text-center py-3">Loading sectors...</div>
                ) : (
                  expandedCategory === category.id && (
                    <div className="transition-all duration-500 ease-in-out">
                      {sectors.length > 0 ? (
                        sectors.map((sector, secIndex) => {
                          const hasSubSectors = sector.sub_sectors && sector.sub_sectors.length > 0;
                          return (
                            <div key={sector.id} ref={el => sectorRefs.current[secIndex] = el}>
                              <div
                                onClick={() => handleSectorSelect(sector, secIndex)}
                                className="cursor-pointer py-3 ps-6 bg-gray-200 transition-all"
                              >
                                <h4 className={`flex items-center gap-2 text-gray-700 hover:bg-gray-800 p-3 py-2 hover:text-white transition-all rounded-lg ${expandedSector === sector.id ? 'bg-CounterTextColor text-white' : 'bg-gray-100'
                                  }`}>
                                  <FaChevronRight className={`transition-transform duration-300 transform ${expandedSector === sector.id ? 'rotate-90' : ''
                                    }`} />

                                  {hasSubSectors ? `Sector ${secIndex + 1}. ` : ''}
                                  {sector.name}
                                </h4>

                              </div>

                              {expandedSector === sector.id && (
                                <div className="transition-all duration-500 ease-in-out">
                                  {subSectors !== null && subSectors.length > 0 ? (
                                    <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 gap-4">
                                      {subSectors.map((subSector, subIndex) => {
                                        // Check if the subSector.name is not null or empty
                                        const isSubSectorValid = subSector.name !== null && subSector.name.trim() !== '';

                                        return (
                                          <div key={subSector.id} className="cursor-pointer ps-10 transition-all">
                                            <h5 onClick={e => { e.preventDefault(); handleChangePreference(subSector.id); }} className={` ps-2 py-2 rounded-lg shadow-md cursor-pointer transition-all 
                ${isSubSectorValid ? 'bg-blue-300 text-gray-800 hover:bg-blue-400' : 'bg-gray-200 text-gray-600'}`}
                                            >
                                              {/* Show index only if subSector.name is not null */}
                                              {isSubSectorValid && `Sub Sector ${subIndex + 1}. `}
          
                                              <span className={subSector.name ? 'text-gray-800' : 'text-red-500 py-1 '}>
                                                  {subSector.name || 'No Subsector available'}
                                                </span>

                                            </h5>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  ) : (
                                    <p className="text-red-600 ms-6 mt-2">No subsectors available</p>
                                  )}
                                </div>
                              )}




                            </div>
                          );
                        })
                      ) : (
                        <p className="text-red-600 ms-6 mt-2">No sectors available</p>
                      )}
                    </div>
                  )
                )}
              </div>
            ))
          ) : (
            <p className="text-red-600 ms-6 mt-2">No categories available.</p>
          )}
        </div>
       </div>
      )}
    </div>
  );
};

export default Categories;


// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { API_BASE_URL } from '../../Api/config';
// import { IoIosArrowDown, IoMdSearch } from "react-icons/io";
// import { GoDotFill } from "react-icons/go";
// import { IoSearchCircleOutline } from 'react-icons/io5';
// import { FaCheckCircle, FaSearch } from 'react-icons/fa';
// import NotFoundPic from "../../Assets/images/tenderNotFoundImage.png"
// import apiClient from '../../Api/apiClient';

// import Swal from 'sweetalert2';

// const Categories = ({ subSector }) => {
//     const [categories, setCategories] = useState([]);
//     const [categoryName, setCategoryName] = useState('');
//     const [sectors, setSectors] = useState([]);
//     const [selectedCategory, setSelectedCategory] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState('');
//     const [searchTerm, setSearchTerm] = useState(''); // State to store search term
//     const [filteredCategories, setFilteredCategories] = useState([]); // State for filtered categories
//     const [categoryIndex, setCategoryIndex] = useState(1)



//     const navigate = useNavigate();

//     const handleCategorySelect = categoryName => {
//         // Navigate to the LimitedTenderView page and pass the selected category name
//         navigate('/limitedTenderView', { state: { categoryName } });
//     };
//     const fetchCategories = async () => {
//         try {
//             setLoading(true);
//             // const response = await apiClient.get('/user/tender-config/category');
//             const response = await axios.get(
//                 `${API_BASE_URL}/user/visitor/category`
//             );

//             const filterByStatus = response.data?.data?.filter(
//                 tender => tender.status === 1
//             );
//             const categories = filterByStatus || [];
//             // const categories = response.data.data || [];
//             setCategories(categories);
//             setFilteredCategories(categories); // Initially set all categories

//             if (categories.length > 0) {
//                 setSelectedCategory(categories[0].id); // Default category
//                 setCategoryName(categories[0].name); // Default category name
//                 fetchSectors(categories[0].id); // Fetch default category's sectors
//             }



//         } catch (err) {
//             setError('Failed to fetch categories.');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const fetchSectors = async categoryId => {
//         try {
//             setLoading(true);
//             // const response = await apiClient.get('/user/tender-config/sector');
//             const response = await axios.get(
//                 `${API_BASE_URL}/user/visitor/sector`
//             );
//             const filterByStatus = response.data?.data?.filter(
//                 tender => tender.sector_status === 1
//             );
//             const sectors = filterByStatus || [];
//             // const sectors = response.data.data || [];

//             // If a category is selected, filter sectors by category ID
//             if (categoryId) {
//                 const filteredSectors = sectors.filter(
//                     sector => sector.category_id === categoryId
//                 );
//                 setSectors(filteredSectors);

//             } else {
//                 setSectors(sectors); // If no category is selected, show all sectors
//             }
//         } catch (err) {
//             setError('Failed to fetch sectors.');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleCategoryChange = (categoryId, categoryName, columnWiseIndex) => {
//         setSelectedCategory(categoryId);
//         setCategoryName(categoryName);
//         fetchSectors(categoryId);
//         setCategoryIndex(columnWiseIndex)
//     };

//     const handleSearchChange = e => {
//         const value = e.target.value;
//         setSearchTerm(value);

//         // Filter categories based on search term
//         const filtered = categories.filter(category =>
//             category.name.toLowerCase().includes(value.toLowerCase())
//         );
//         setFilteredCategories(filtered);
//     };

//     useEffect(() => {
//         fetchCategories();
//         fetchSectors(null); // Fetch all sectors when the component is mounted
//     }, []);




//     const [activeSector, setActiveSector] = useState(null);
//     const [openIndex, setOpenIndex] = useState(null);

//     const sectorRefs = useRef([]); // Refs for FAQ items

//     const handleSectorClick = (sectorId) => {
//         setActiveSector(sectorId);
//         setOpenIndex(sectorId); // Automatically expand the clicked FAQ

//         // Scroll to the corresponding FAQ item
//         const refIndex = sectors.findIndex((sector) => sector.id === sectorId);
//         if (refIndex !== -1 && sectorRefs.current[refIndex]) {
//             sectorRefs.current[refIndex].scrollIntoView({ behavior: "smooth", block: "start" });
//         }
//     };


//     useEffect(() => {
//         if (!activeSector && sectors.length > 0) {

//             const defaultSectorId = sectors[0].id;
//             setActiveSector(defaultSectorId);
//             setOpenIndex(defaultSectorId);
//         }
//     }, [sectors, activeSector]);

//     const toggleAccordion = (index) => {
//         setOpenIndex(openIndex === index ? null : index);
//         if (openIndex !== index) {
//             setActiveSector(index);
//         }
//     };



//     const handleChangePreference = async (sub_sector_id) => {
//         try {
//             const response = await apiClient.patch(
//                 `${API_BASE_URL}/user/tender-user/category-upazila`,
//                 { sub_sector_id: sub_sector_id }
//             );

//             console.log('API Response:', response.data);

//             Swal.fire({
//               title: 'Success!',
//               text: 'The preference was updated successfully.',
//               icon: 'success',
//               confirmButtonText: 'OK',
//               customClass: {
//                 popup: 'w-96 h-auto p-3',
//                 title: 'text-lg',
//                 content: 'text-xs',
//                 confirmButton:
//                   'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
//               },
//             });

//             navigate('/dashboard');
            
//         } catch (error) {

//             console.error('Error fetching data:', error);


//             Swal.fire({
//                 title: 'Error!',
//                 text: 'There was an issue updating the preference.',
//                 icon: 'error',
//                 confirmButtonText: 'Try Again',
//             });
//         }
//     };




//     return (
//         <div className=" mt-44 md:mt-40 lg:mt-40   py-1">
//             <div className="flex flex-col md:flex-row  md:justify-between mx-10 my-2 items-center gap-2">
//                 <h1 className=" text-xm sm:text-sm md:text-2xl lg:text-xl border-b-2 border-gray-500  text-start ">
//                     All Categories
//                 </h1>

//                 <div className="flex items-center justify-center px-4 w-full md:w-1/2 lg:w-1/2">
//                     <div className="relative w-full ">
//                         <input
//                             value={searchTerm}
//                             onChange={handleSearchChange}
//                             type="text"
//                             placeholder="Categories Name"
//                             className="w-full  py-1 md:py-2 pl-4 pr-12 border border-gray-400 rounded shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
//                         />
//                         <button className="absolute inset-y-0 right-1 m-1 px-2 text-white bg-modalHeader rounded hover:bg-blue-700">
//                             <div className="flex gap-1 items-center text-sm md:text-base lg:text-lg">
//                                 <FaSearch className="w-3 h-3 md:w-4 md:h-4 lg:w-5 lg:h-5" />
//                                 <span className="hidden sm:inline lg:inline md:inline">
//                                     Search
//                                 </span>
//                             </div>
//                         </button>
//                     </div>
//                 </div>
//             </div>

//             {/* Categories Section */}
//             <div
//                 className={`gap-2 mx-2 md:mx-7 gap-x-5 md:gap-x-14 lg:gap-x-20 lg:mx-9 mt-4 md:text-sm text-xs px-4  ${filteredCategories.length > 0
//                     ? 'h-[200px] md:h-[250px] lg:h-[300px] overflow-y-auto'
//                     : ''
//                     }`}
//             >
//                 {loading ? (
//                     <div className="flex justify-center items-center">
//                         <p className="text-lg">Loading...</p>
//                     </div>
//                 ) : filteredCategories.length > 0 ? (
//                     <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3  gap-4  gap-x-5 md:gap-x-24 lg:gap-x-28">
//                         {filteredCategories.map((category, index) => {
//                             const numberOfColumns = 3; // Adjust based on your grid-cols value
//                             const columnWiseIndex = index + 1;

//                             return (
//                                 <div
//                                     key={category.id}
//                                     onClick={() =>
//                                         handleCategoryChange(
//                                             category.id,
//                                             category.name,
//                                             columnWiseIndex
//                                         )
//                                     }
//                                     className={`flex flex-col items-start justify-start py-1  rounded-md cursor-pointer 
//     ${selectedCategory === category.id
//                                             ? 'bg-modalHeader text-white'
//                                             : 'bg-slate-100 text-gray-600 border-disableBorder'
//                                         }`}
//                                 >
//                                     <div className="flex items-center px-3 ">
//                                         <h2 className="md:text-sm text-left text-xs md:mt-1 mt-2 flex items-center gap-1 ">
//                                             <span
//                                                 className={`${selectedCategory === category.id
//                                                     ? 'text-white'
//                                                     : 'text-gray-600 '
//                                                     }`}
//                                             >
//                                                 {columnWiseIndex}
//                                             </span>
//                                             . {category.name}
//                                             {selectedCategory === category.id && (
//                                                 <FaCheckCircle className="text-white text-sm md:text-base" />
//                                             )}
//                                         </h2>
//                                     </div>
//                                 </div>
//                             );
//                         })}
//                     </div>
//                 ) : (
//                     <div className="flex justify-center items-center h-full">
//                         <img
//                             className="max-w-full h-full"
//                             src={NotFoundPic}
//                             alt="Not Found"
//                         />
//                     </div>
//                 )}
//             </div>

//             {/* Sectors Section */}
//             <div className="flex flex-col items-start md:flex-row gap-4 px-6 pt-2 mt-5  bg-white rounded-t-lg min-h-auto">
//                 {/* Sidebar for Sectors */}
//                 <div
//                     className="bg-white shadow-md rounded-lg p-4 w-full md:w-1/4 overflow-y-auto"
//                     style={{ maxHeight: '80vh' }} // Fixed height with scrolling
//                 >
//                     <h2 className=" text-xm sm:text-sm md:text-2xl lg:text-xl border-b-2 border-gray-500  text-start mb-4">
//                         All sectors:
//                     </h2>
//                     <ul className="space-y-2 ">
//                         {sectors.map((sector, index) => (
//                             <li
//                                 key={sector.id}
//                                 onClick={() => handleSectorClick(sector.id)}
//                                 className={`cursor-pointer p-2 text-blue-700 rounded-md ${activeSector === sector.id
//                                     ? 'bg-blue-200 text-black font-semibold'
//                                     : 'hover:bg-gray-200'
//                                     }`}
//                             >
//                                 {index + 1}. {sector.name}
//                             </li>
//                         ))}
//                     </ul>
//                 </div>

//                 {/* FAQ Section */}
//                 <div
//                     className=" bg-white rounded  w-full md:w-3/4 overflow-y-auto"
//                     style={{ maxHeight: '80vh' }} // Fixed height with scrolling
//                 >
//                     <h1 className="text-start rounded py-2 px-3 bg-modalHeader text-white text-xm sm:text-sm md:text-2xl lg:text-xl ">
//                         {' '}
//                         {categoryIndex}. {categoryName}
//                     </h1>
//                     {activeSector ? (
//                         <>
//                             <ul className="flex flex-col rounded">
//                                 {sectors
//                                     .filter(sector => sector.id === activeSector)
//                                     .map(sector => (
//                                         <li
//                                             ref={el => (sectorRefs.current[sector.id] = el)} // Attach ref to each FAQ item
//                                             key={sector.id}
//                                             className="my-2 bg-faqSectionBg mb-2 rounded"

//                                         >
//                                             <h2 onClick={() => toggleAccordion(sector.id)} className="flex flex-row justify-start gap-3 items-center font-semibold p-3 cursor-pointer">
//                                                 <IoIosArrowDown
//                                                     size={15}
//                                                     className={`fill-current transform transition-transform duration-500 ${openIndex === sector.id ? 'rotate-180' : ''
//                                                         }`}
//                                                 />
//                                                 <span className="flex items-center gap-2 text-gray-700 md:text-sm text-xs">
//                                                     Sector {sectors.indexOf(sector) + 1} : {sector.name}, {sector.id}
//                                                 </span>
//                                             </h2>
//                                             <div
//                                                 className={`overflow-hidden duration-500 transition-all ease-in-out ${openIndex === sector.id ? 'max-h-[1000px]' : 'max-h-0'
//                                                     }`}
//                                             >
//                                                 {/* <ul className="list-decimal list-inside pl-6 text-gray-600 md:text-sm text-xs grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 py-3 gap-x-5 md:gap-x-24 lg:gap-x-28">
//                           {sector.sub_sectors.map(subSector => (
//                             <li
//                               onClick={e => {
//                                 e.preventDefault();
//                                 handleCategorySelect(subSector.name);
//                               }}
//                               className="py-2 cursor-pointer hover:bg-modalHeader hover:text-white p-2 rounded-md"
//                               key={subSector.id}
//                             >
//                               {subSector.name}
//                             </li>
//                           ))}
//                         </ul> */}


//                                                 <ul className="list-decimal list-inside pl-6 text-gray-600 md:text-sm text-xs grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 py-3 gap-x-5 md:gap-x-24 lg:gap-x-28">
//                                                     {sector.sub_sectors.some(subSector => subSector.name) && (
//                                                         sector.sub_sectors.map((subSector) => (
//                                                             subSector.name && (
//                                                                 <li className="py-2 cursor-pointer" key={subSector.id} onClick={() => handleChangePreference(subSector.id)} >
//                                                                     {subSector.name}
//                                                                 </li>
//                                                             )
//                                                         ))
//                                                     )}

//                                                 </ul>

//                                             </div>
//                                         </li>
//                                     ))}
//                             </ul>
//                         </>
//                     ) : (
//                         <p className="text-gray-600">No Category selected</p>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Categories;
